import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { CheckSquare } from 'lucide-react';
import { Square } from 'lucide-react';
import { ListChecks } from 'lucide-react';
const Container = styled.div`
  background: var(--vscode-editor-background, var(--theme-paper));
  border: 1px solid var(--vscode-editorWidget-border, var(--theme-border));
  border-radius: var(--theme-radius-md, 8px);
  padding: var(--theme-spacing-lg, 24px);
  margin: var(--theme-spacing-lg, 24px) 0;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--theme-spacing-md, 16px);
`;
const Title = styled.h4`
  margin: 0;
  font-size: var(--theme-typography-font-size-base, 1rem);
  font-weight: var(--theme-typography-font-weight-semibold, 600);
  color: var(--vscode-editor-foreground, var(--theme-text));
  display: flex;
  align-items: center;
  gap: var(--theme-spacing-sm, 8px);
  
  svg {
    color: var(--vscode-textLink-foreground, var(--theme-primary));
  }
`;
const Progress = styled.div`
  font-size: var(--theme-typography-font-size-sm, 0.875rem);
  color: var(--vscode-descriptionForeground, var(--theme-text-secondary));
`;
const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: var(--vscode-progressBar-background, #e0e0e0);
  border-radius: 4px;
  margin-bottom: var(--theme-spacing-md, 16px);
  overflow: hidden;
`;
const ProgressFill = styled.div`
  height: 100%;
  width: ${(props)=>props.progress}%;
  background: var(--vscode-progressBar-foreground, var(--theme-success));
  transition: width 0.3s ease;
`;
const ChecklistItems = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
const ChecklistItem = styled.li`
  display: flex;
  align-items: center;
  gap: var(--theme-spacing-sm, 8px);
  margin-bottom: var(--theme-spacing-sm, 8px);
  cursor: pointer;
  padding: var(--theme-spacing-xs, 4px);
  border-radius: var(--theme-radius-sm, 4px);
  transition: background-color 0.2s;
  
  &:hover {
    background: var(--vscode-list-hoverBackground, rgba(0, 0, 0, 0.04));
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;
const ItemText = styled.span`
  color: var(--vscode-editor-foreground, var(--theme-text));
  font-size: var(--vscode-font-size, var(--theme-typography-font-size-sm, 0.875rem));
  text-decoration: ${(props)=>props.checked ? 'line-through' : 'none'};
  opacity: ${(props)=>props.checked ? 0.7 : 1};
  transition: all 0.2s;
`;
const ProgressChecklist = ({ title, items })=>{
    const [checkedItems, setCheckedItems] = useState(new Set());
    // 로컬 스토리지에서 체크 상태 복원
    useEffect(()=>{
        const storageKey = `checklist-${title}`;
        const saved = localStorage.getItem(storageKey);
        if (saved) {
            setCheckedItems(new Set(JSON.parse(saved)));
        }
    }, [
        title
    ]);
    // 체크 상태 로컬 스토리지에 저장
    useEffect(()=>{
        const storageKey = `checklist-${title}`;
        localStorage.setItem(storageKey, JSON.stringify(Array.from(checkedItems)));
    }, [
        checkedItems,
        title
    ]);
    const toggleItem = (id)=>{
        setCheckedItems((prev)=>{
            const newSet = new Set(prev);
            if (newSet.has(id)) {
                newSet.delete(id);
            } else {
                newSet.add(id);
            }
            return newSet;
        });
    };
    const progress = items.length > 0 ? checkedItems.size / items.length * 100 : 0;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(Header, {
                children: [
                    /*#__PURE__*/ _jsxs(Title, {
                        children: [
                            /*#__PURE__*/ _jsx(ListChecks, {
                                size: 20
                            }),
                            title
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Progress, {
                        children: [
                            checkedItems.size,
                            "/",
                            items.length,
                            " 완료"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ProgressBar, {
                children: /*#__PURE__*/ _jsx(ProgressFill, {
                    progress: progress
                })
            }),
            /*#__PURE__*/ _jsx(ChecklistItems, {
                children: items.map((item)=>/*#__PURE__*/ _jsxs(ChecklistItem, {
                        onClick: ()=>toggleItem(item.id),
                        children: [
                            checkedItems.has(item.id) ? /*#__PURE__*/ _jsx(CheckSquare, {
                                size: 18,
                                color: "var(--vscode-testing-iconPassed, #4CAF50)"
                            }) : /*#__PURE__*/ _jsx(Square, {
                                size: 18,
                                color: "var(--vscode-descriptionForeground, #666)"
                            }),
                            /*#__PURE__*/ _jsx(ItemText, {
                                checked: checkedItems.has(item.id),
                                children: item.text
                            })
                        ]
                    }, item.id))
            })
        ]
    });
};
// Default export for backward compatibility
export default ProgressChecklist;
